import React from 'react';
import s from './DownloadStatement.module.css'
import print from '../../../../../assets/newImg/personalAccount/print.svg'
import {Api} from "../../../../../api/Api";
import {useAppSelector} from "../../../../../hooks/redux";

const DownloadStatement = (props: any) => {

    const token = useAppSelector(state => state.userReducer.user.userToken)

    const accountInfo = {
        accountNumber:  props?.dataForStatement?.accountNumber,
        dateFrom: props?.dataForStatement?.from,
        dateTo: props?.dataForStatement?.to,
        transferType: "all"
    }

    console.log(accountInfo)

    const getStatement = () => {
        Api.getStatement(token, accountInfo)
            .then((res: any) => {
                console.log(res)
                const url = process.env.REACT_APP_API_URL + res.data
                window.open(url, '_blank');
            }
        )
    }

    return (

        <div className={s.statementWrapper} >
            <div className={s.buttonsWrapper}>
                <p className={s.downloadTitle}>Download as</p>
                <p className={s.buttonTitle} onClick={() => getStatement()}>PDF</p>
            </div>
        </div>
    )
}


export default DownloadStatement
